<template>
  <div id="container" style="width: 1500px;margin-left:5%">
  </div>
</template>

<script>
import { Graph } from '@antv/x6'
let graph = null
export default {
  mounted: function () {
    this.preWork();
    // #region 初始化画布
    graph = new Graph({
      container: document.getElementById('container'),
      width:'100%',
      height:200,
      grid: false,
      interacting: false,
      mousewheel: {
        enabled: false,
        zoomAtMousePosition: true,
        modifiers: 'ctrl',
        minScale: 0.5,
        maxScale: 3,
      },
      connecting: {
        router: {
          name: 'manhattan',
          args: {
            padding: 1,
          },
        },
        connector: {
          name: 'rounded',
          args: {
            radius: 2,
          },
        },
        // anchor: 'center',
        // connectionPoint: 'anchor',
        allowBlank: false,
        snap: {
          radius: 20,
        },
        // createEdge() {
        //   return new Shape.Edge({
        //     attrs: {
        //       line: {
        //         stroke: '#A2B1C3',
        //         strokeWidth: 2,
        //         targetMarker: {
        //           name: 'block',
        //           width: 12,
        //           height: 8,
        //         },
        //       },
        //     },
        //     zIndex: 0,
        //   })
        // },
        validateConnection({ targetMagnet }) {
          return !!targetMagnet
        },
      },
      highlighting: {
        magnetAdsorbed: {
          name: 'stroke',
          args: {
            attrs: {
              fill: '#5F95FF',
              stroke: '#5F95FF',
            },
          },
        },
      },
      resizing: false,
      rotating: false,
      selecting: {
        enabled: true,
        rubberband: false,
        showNodeSelectionBox: true,
        multiple:false,
        // filter:['custom-rect'],
      },
      snapline: false,
      keyboard: false,
      clipboard: false,
    });

    graph.fromJSON(this.flowData)

// zoom
    graph.bindKey(['ctrl+1', 'meta+1'], () => {
      const zoom = graph.zoom()
      if (zoom < 1.5) {
        graph.zoom(0.1)
      }
    })
    graph.bindKey(['ctrl+2', 'meta+2'], () => {
      const zoom = graph.zoom()
      if (zoom > 0.5) {
        graph.zoom(-0.1)
      }
    })
    // graph.select("node2")
    // graph.select("node3")
    graph.on('node:mouseenter', ({node}) => {
      showNodePorts(node.port.ports, true)
    })
    graph.on('node:mouseleave', ({node}) => {
      showNodePorts(node.port.ports, false)
    })
    graph.on('node:selected',({node}) => {
      showNodePorts(node.port.ports, false)
      if(!this.selectedStrict){
        this.$emit('selectChange',{node});
        return;
      }
      if(node.id != "node3" && node.id != "node4" && node.id != "node5" && this.lastUnselNode != null)
      {
        graph.select(this.lastUnselNode.id)
        graph.unselect(node.id)
      }
      else{
        this.$emit('selectChange',{node});
      }
      this.lastUnselNode = null;
    })
    graph.on('node:unselected',({node}) => {
      if(!this.selectedStrict){
        return;
      }
      this.lastUnselNode = node;
    })
    graph.on('blank:click',() =>{
      if(!this.selectedStrict){
        return;
      }
      if(this.lastUnselNode != null){
        graph.select(this.lastUnselNode.id)
      }
    })
  },
  props: {
    selectedStrict: {
      default: true
    }
  },
  methods: {
    preWork() {
    },
    //设置选中节点
    setSelectNode(nodeID){
      if(graph!=null && nodeID.length>0){
        graph.resetSelection(nodeID)
      }
    },
    //设置容器样式
    setContainerStyle(value){
      let containerDom = document.getElementById('container');
      console.log(containerDom)
      containerDom.style.marginLeft = value;
    },
    //设置节点名称
    setNodeLabel(nodeID,label){
      graph.model.getCell(nodeID).label = label
    },
    setEdgeStatus(edgeID,status){
      console.log("EDGE:",graph.model.getEdges())
      let edgeList = graph.model.getEdges();
      for(let idx=0;idx<edgeList.length;idx++)
      {
        let edge = edgeList[idx];
        if(edge.id == edgeID)
        {
          edge.attr({
            line:{
              stroke:status?"#FF0000":"#A2B1C3",
            }
          });
          return;
        }
      }
    },
    //设置审核节点状态(仅初审、终审)目前是死方法
    setNodeStatus(nodeID,stat){
      if(graph!=null && nodeID.length>0){
        let nodeDom = document.getElementsByClassName(nodeID+'Attr');
        if(nodeDom == undefined)
          return;
        nodeDom[0].setAttribute("fill",stat?'#EFF4FF':'#f5f5f5');
        nodeDom[0].setAttribute("stroke",stat?'#5F95FF':'#d9d9d9');
        //262626
        let flowTextDom = document.getElementsByClassName('v-line');
        let judgeText = nodeID == "node3"?"一级审核":nodeID == "node4"?"二级审核":nodeID == "node5"?"油田公司审核":"";
        if(judgeText == "" || flowTextDom == undefined)
          return;
        for(let idx=0;idx<flowTextDom.length;idx++)
        {
          if(flowTextDom[idx].innerHTML== judgeText){
            if(flowTextDom[idx].parentNode != undefined){
              flowTextDom[idx].parentNode.setAttribute("fill",stat?'#262626':'#d9d9d9');
            }
          }
        }
      }
    }
  },
  data() {
    return {
      lastUnselNode:null,
      flowData: {
        // 节点
        nodes: [
          {
            id: 'node1', // String，可选，节点的唯一标识
            x: 10,       // Number，必选，节点位置的 x 值
            y: 40,       // Number，必选，节点位置的 y 值
            shape: 'custom-rect',// 使用 ellipse 渲染,默认长方形
            label: "考核指标发布",
            attrs: {
              body: {
                rx: 20,
                ry: 26,
              },
            },
          },
          {
            id: 'node2', // String，可选，节点的唯一标识
            x: 160,       // Number，必选，节点位置的 x 值
            y: 40,       // Number，必选，节点位置的 y 值
            shape: 'custom-rect',// 使用 ellipse 渲染,默认长方形
            label: "资料送审",
            // attrs: {
            //   body: {
            //     rx: 20,
            //     ry: 26,
            //   },
            // },
          },
          {
            id: 'node3', // String，节点的唯一标识
            x: 310,      // Number，必选，节点位置的 x 值
            y: 40,      // Number，必选，节点位置的 y 值
            shape: 'custom-polygon',
            label: "一级审核",
            attrs: {
              body: {
                class:"node3Attr"
              }
            }
          },
          {
            id: 'node4', // String，节点的唯一标识
            x: 510,      // Number，必选，节点位置的 x 值
            y: 40,      // Number，必选，节点位置的 y 值
            shape: 'custom-polygon',
            label: "二级审核",
            attrs: {
              body: {
                class:"node4Attr"
              }
            }
          },
          {
            id: 'node5', // String，节点的唯一标识
            x: 710,      // Number，必选，节点位置的 x 值
            y: 40,      // Number，必选，节点位置的 y 值
            shape: 'custom-polygon',
            label: "油田公司审核",
            attrs: {
              body: {
                class:"node5Attr"
              }
            }
          },
          {
            id: 'node6', // String，可选，节点的唯一标识
            x: 910,       // Number，必选，节点位置的 x 值
            y: 40,       // Number，必选，节点位置的 y 值
            shape: 'custom-rect',// 使用 ellipse 渲染,默认长方形
            label: "资料完善",
            // attrs: {
            //   body: {
            //     rx: 20,
            //     ry: 26,
            //   },
            // },
          },
          {
            id: 'node7', // String，节点的唯一标识
            x: 1060,      // Number，必选，节点位置的 x 值
            y: 40,      // Number，必选，节点位置的 y 值
            shape: 'custom-rect',
            label: "考核评分发布",
            attrs: {
              body: {
                rx: 20,
                ry: 26,
              },
            }
          },
          {
            id: 'node8', // String，节点的唯一标识
            x: 315,      // Number，必选，节点位置的 x 值
            y: 140,      // Number，必选，节点位置的 y 值
            shape: 'custom-rect',
            label: "资料修改",
            // attrs: {
            //   body: {
            //     rx: 20,
            //     ry: 26,
            //   },
            // }
          },
          {
            id: 'node9', // String，节点的唯一标识
            x: 515,      // Number，必选，节点位置的 x 值
            y: 140,      // Number，必选，节点位置的 y 值
            shape: 'custom-rect',
            label: "资料修改",
            // attrs: {
            //   body: {
            //     rx: 20,
            //     ry: 26,
            //   },
            // }
          },
          {
            id: 'node10', // String，节点的唯一标识
            x: 715,      // Number，必选，节点位置的 x 值
            y: 140,      // Number，必选，节点位置的 y 值
            shape: 'custom-rect',
            label: "资料修改",
            // attrs: {
            //   body: {
            //     rx: 20,
            //     ry: 26,
            //   },
            // }
          }
        ],
        // 边
        edges: [
          {
            id:'Edge1',
            source: 'node1', // String，必须，起始节点 id
            target: 'node2', // String，必须，目标节点 id
            attrs: {
              line: {
                stroke: '#A2B1C3',
                strokeWidth: 2,
                targetMarker: {
                  name: 'block',
                  width: 12,
                  height: 8,
                },
              },
            },
          },
          {
            id:'Edge2',
            source: 'node2', // String，必须，起始节点 id
            target: 'node3', // String，必须，目标节点 id
            attrs: {
              line: {
                stroke: '#A2B1C3',
                strokeWidth: 2,
                targetMarker: {
                  name: 'block',
                  width: 12,
                  height: 8,
                },
              },
            },
          },
          {
            id:'Edge3',
            source: 'node3', // String，必须，起始节点 id
            target: 'node4', // String，必须，目标节点 id
            label:"通过",
            attrs: {
              line: {
                stroke: '#A2B1C3',
                strokeWidth: 2,
                targetMarker: {
                  name: 'block',
                  width: 12,
                  height: 8,
                },
              },
              text: {
                fontSize: 11
              },
            },
          },
          {
            id:'Edge4',
            source: 'node4', // String，必须，起始节点 id
            target: 'node5', // String，必须，目标节点 id
            label:"通过",
            attrs: {
              line: {
                stroke: '#A2B1C3',
                strokeWidth: 2,
                targetMarker: {
                  name: 'block',
                  width: 12,
                  height: 8,
                },
              },
              text: {
                fontSize: 11
              },
            },
          },
          {
            id:'Edge5',
            source: 'node5', // String，必须，起始节点 id
            target: 'node6', // String，必须，目标节点 id
            label:"通过",
            attrs: {
              line: {
                stroke: '#A2B1C3',
                strokeWidth: 2,
                targetMarker: {
                  name: 'block',
                  width: 12,
                  height: 8,
                },
              },
              text: {
                fontSize: 11
              },
            },
          },
          {
            id:'Edge6',
            source: 'node6', // String，必须，起始节点 id
            target: 'node7', // String，必须，目标节点 id
            attrs: {
              line: {
                stroke: '#A2B1C3',
                strokeWidth: 2,
                targetMarker: {
                  name: 'block',
                  width: 12,
                  height: 8,
                },
              },
            },
          },
          {
            id:'Edge7',
            source: 'node3', // String，必须，起始节点 id
            target: 'node8', // String，必须，目标节点 id
            label:"未通过",
            attrs: {
              line: {
                stroke: '#A2B1C3',
                strokeWidth: 2,
                targetMarker: {
                  name: 'block',
                  width: 12,
                  height: 8,
                },
              },
              text: {
                fontSize: 11
              },
            },
          },
          {
            id:'Edge8',
            source: 'node8', // String，必须，起始节点 id
            target: 'node3', // String，必须，目标节点 id
            label:"",
            router: {
              name: 'manhattan',
              args: {
                startDirections: ['left'],
                endDirections: ['left'],
              },
            },
            attrs: {
              line: {
                stroke: '#A2B1C3',
                strokeWidth: 2,
                targetMarker: {
                  name: 'block',
                  width: 12,
                  height: 8,
                },
              },
              text: {
                fontSize: 11
              },
            },
          },
          {
            id:'Edge9',
            source: 'node4', // String，必须，起始节点 id
            target: 'node9', // String，必须，目标节点 id
            label:"未通过",
            attrs: {
              line: {
                stroke: '#A2B1C3',
                strokeWidth: 2,
                targetMarker: {
                  name: 'block',
                  width: 12,
                  height: 8,
                },
              },
              text: {
                fontSize: 11
              },
            },
          },
          {
            id:'Edge10',
            source: 'node9', // String，必须，起始节点 id
            target: 'node4', // String，必须，目标节点 id
            label:"",
            router: {
              name: 'manhattan',
              args: {
                startDirections: ['left'],
                endDirections: ['left'],
              },
            },
            attrs: {
              line: {
                stroke: '#A2B1C3',
                strokeWidth: 2,
                targetMarker: {
                  name: 'block',
                  width: 12,
                  height: 8,
                },
              },
              text: {
                fontSize: 11
              },
            },
          },
          {
            id:'Edge11',
            source: 'node5', // String，必须，起始节点 id
            target: 'node10', // String，必须，目标节点 id
            label:"未通过",
            attrs: {
              line: {
                stroke: '#A2B1C3',
                strokeWidth: 2,
                targetMarker: {
                  name: 'block',
                  width: 12,
                  height: 8,
                },
              },
              text: {
                fontSize: 11
              },
            },
          },
          {
            id:'Edge12',
            source: 'node10', // String，必须，起始节点 id
            target: 'node5', // String，必须，目标节点 id
            label:"",
            router: {
              name: 'manhattan',
              args: {
                startDirections: ['left'],
                endDirections: ['left'],
              },
            },
            attrs: {
              line: {
                stroke: '#A2B1C3',
                strokeWidth: 2,
                targetMarker: {
                  name: 'block',
                  width: 12,
                  height: 8,
                },
              },
              text: {
                fontSize: 11
              },
            },
          },
        ]
      }
    }
  }
}


// #endregion


// #endregion



// 控制连接桩显示/隐藏
// const showPorts = (show) => {
//   const container = document.getElementById('container')
//   const ports = container.querySelectorAll(
//       '.x6-port-body',
//   )
//   for (let i = 0, len = ports.length; i < len; i = i + 1) {
//     ports[i].style.visibility = show ? 'visible' : 'hidden'
//   }
// }

const showNodePorts = (ports, show) => {
  const container = document.getElementById('container')
  const domPorts = container.querySelectorAll(
      '.x6-port-body',
  )
  for (let i = 0, len = domPorts.length; i < len; i = i + 1) {
    for (let j = 0, jlen = ports.length; j < jlen; j = j + 1) {
      if(ports[j].id == domPorts[i].attributes.port.value){
        domPorts[i].style.visibility = show ? 'visible' : 'hidden'
      }
    }
  }

}

// #endregion

// #region 初始化图形
const ports = {
  groups: {
    top: {
      position: 'top',
      attrs: {
        circle: {
          r: 4,
          magnet: true,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'hidden',
          },
        },
      },
    },
    right: {
      position: 'right',
      attrs: {
        circle: {
          r: 4,
          magnet: true,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'hidden',
          },
        },
      },
    },
    bottom: {
      position: 'bottom',
      attrs: {
        circle: {
          r: 4,
          magnet: true,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'hidden',
          },
        },
      },
    },
    left: {
      position: 'left',
      attrs: {
        circle: {
          r: 4,
          magnet: true,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'hidden',
          },
        },
      },
    },
  },
  items: [
    {
      group: 'top',
    },
    {
      group: 'right',
    },
    {
      group: 'bottom',
    },
    {
      group: 'left',
    },
  ],
}

Graph.registerNode(
    'custom-rect',
    {
      inherit: 'rect',
      width: 100,
      height: 50,
      attrs: {
        body: {
          strokeWidth: 1,
          stroke: '#5F95FF',
          fill: '#EFF4FF',
        },
        text: {
          fontSize: 16,
          fill: '#262626',
        },
      },
      ports: { ...ports },
    },
    true,
)

Graph.registerNode(
    'custom-polygon',
    {
      inherit: 'polygon',
      width: 110,
      height: 50,
      attrs: {
        body: {
          refPoints: '0,10 10,0 20,10 10,20',
          strokeWidth: 1,
          stroke: '#5F95FF',
          fill: '#EFF4FF',
        },
        text: {
          fontSize: 16,
          fill: '#262626',
        },
      },
      ports: {
        ...ports,
        // items: [
        //   {
        //     group: 'top',
        //   },
        //   {
        //     group: 'bottom',
        //   },
        // ],
      },
    },
    true,
)

Graph.registerNode(
    'custom-circle',
    {
      inherit: 'circle',
      width: 45,
      height: 45,
      attrs: {
        body: {
          strokeWidth: 1,
          stroke: '#5F95FF',
          fill: '#EFF4FF',
        },
        text: {
          fontSize: 12,
          fill: '#262626',
        },
      },
      ports: { ...ports },
    },
    true,
)

Graph.registerNode(
    'custom-image',
    {
      inherit: 'rect',
      width: 52,
      height: 52,
      markup: [
        {
          tagName: 'rect',
          selector: 'body',
        },
        {
          tagName: 'image',
        },
        {
          tagName: 'text',
          selector: 'label',
        },
      ],
      attrs: {
        body: {
          stroke: '#5F95FF',
          fill: '#5F95FF',
        },
        image: {
          width: 26,
          height: 26,
          refX: 13,
          refY: 16,
        },
        label: {
          refX: 3,
          refY: 2,
          textAnchor: 'left',
          textVerticalAnchor: 'top',
          fontSize: 12,
          fill: '#fff',
        },
      },
      ports: { ...ports },
    },
    true,
)
// #endregion
</script>
<style>
/*#container {*/
/*  display: flex;*/
/*  border: 1px solid #dfe3e8;*/
/*}*/
/*#stencil {*/
/*  width: 180px;*/
/*  height: 100%;*/
/*  !*position: relative;*!*/
/*  border-right: 1px solid #dfe3e8;*/
/*}*/
/*#graph-container {*/
/*  width: calc(100% - 180px);*/
/*  height: 500px;*/
/*}*/
/*.x6-widget-stencil  {*/
/*  background-color: #fff;*/
/*}*/
/*.x6-widget-stencil-title {*/
/*  background-color: #fff;*/
/*}*/
/*.x6-widget-stencil-group-title {*/
/*  background-color: #fff !important;*/
/*}*/
/*.x6-widget-transform {*/
/*  margin: -1px 0 0 -1px;*/
/*  padding: 0px;*/
/*  border: 1px solid #239edd;*/
/*}*/
/*.x6-widget-transform > div {*/
/*  border: 1px solid #239edd;*/
/*}*/
/*.x6-widget-transform > div:hover {*/
/*  background-color: #3dafe4;*/
/*}*/
/*.x6-widget-transform-active-handle {*/
/*  background-color: #3dafe4;*/
/*}*/
/*.x6-widget-transform-resize {*/
/*  border-radius: 0;*/
/*}*/
/*.x6-widget-selection-inner {*/
/*  border: 1px solid #239edd;*/
/*}*/
/*.x6-widget-selection-box {*/
/*  opacity: 0;*/
/*}*/
</style>